import { render, staticRenderFns } from "./AttachmentPage.vue?vue&type=template&id=29571859&scoped=true&"
import script from "./AttachmentPage.vue?vue&type=script&lang=js&"
export * from "./AttachmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29571859",
  null
  
)

export default component.exports